import { Component } from '@angular/core';

@Component({
  selector: 'choose-notifications',
  templateUrl: './choose-notifications.component.html',
})
export class ChooseNotificationsComponent {}
